module.exports = "<div id=slider _v-3dad789a=\"\"><swiper class=swiper-box :options=swiperOption ref=swiper _v-3dad789a=\"\"><swiper-slide class=swiper-item v-for=\"image in slideImages\" :style=\"image.url | bgImage\" _v-3dad789a=\"\"></swiper-slide></swiper></div>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-3dad789a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./assets/component/video_image_slider.vue
// module id = 369
// module chunks = 0